import EntityNotificationsDelete from './EntityNotificationsDelete';

export default EntityNotificationsDelete;
